document.addEventListener('DOMContentLoaded', function() {
  const cookieConsent = document.getElementById('cookie-consent');
  const cookieAccept  = document.getElementById('cookie-accept');

  // ⛔ Если баннера/кнопки нет на странице — выходим, не ломая остальной JS
  if (!cookieConsent || !cookieAccept) return;

  const CONSENT_KEY = 'cookie_consent_accepted';

  let alreadyAccepted = false;
  try {
    alreadyAccepted = localStorage.getItem(CONSENT_KEY) === 'true';
  } catch (e) {
    console.warn('localStorage недоступен:', e);
  }

  if (!alreadyAccepted) {
    setTimeout(() => {
      cookieConsent.classList.add('show');
    }, 1000);
  } else {
    cookieConsent.classList.remove('show');
  }

  cookieAccept.addEventListener('click', function() {
    saveConsent();
    hideCookieBanner();
  });

  // Закрытие по клику вне баннера
  document.addEventListener('click', function(e) {
    if (
      cookieConsent.classList.contains('show') &&
      !cookieConsent.contains(e.target)
    ) {
      saveConsent();
      hideCookieBanner();
    }
  });

  // Закрытие по ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cookieConsent.classList.contains('show')) {
      saveConsent();
      hideCookieBanner();
    }
  });

  function saveConsent() {
    try {
      localStorage.setItem(CONSENT_KEY, 'true');
    } catch (e) {
      console.warn('Не удалось сохранить согласие в localStorage:', e);
    }
  }

  function hideCookieBanner() {
    cookieConsent.classList.remove('show');
  }
});
